import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'windmoeller_u_hoelscher',
} as IModuleProps;
